import { type PropsWithChildren } from 'react'
import { ChevronLeftIcon, CloseIcon } from '@dhl-ui/icons'
import { spacing } from '../../theme'
import { useSpacingToken } from '../../theme/hooks/use-spacing-token'
import { Box } from '../../primitives/Box'
import { Ellipsis } from '../../primitives/Ellipsis'
import { IconButton } from '../../primitives/IconButton'
import { type ModalProps } from './types'

export type HeaderProps = PropsWithChildren<Pick<ModalProps, 'onClose' | 'onBack' | 'title' | 'isCloseable'>>

export const ModalHeader = ({ title, children, onClose, onBack, isCloseable = true }: HeaderProps) => {
  const spacingToken = useSpacingToken()

  return (
    <Box sx={{ display: 'flex', gap: spacing(2), padding: spacing(2, spacingToken, 0) }} className="DhlModal-header">
      {onBack && (
        <IconButton
          aria-label="back"
          onClick={onBack}
          size="small"
          data-testid="modal-header-back"
          sx={{ alignSelf: 'center' }}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}

      <Box sx={{ py: spacing(1), flex: 1 }}>
        {children || (
          <Ellipsis lineClamp={2} variant="h5" component="h2">
            {title || ''}
          </Ellipsis>
        )}
      </Box>

      {isCloseable && onClose && (
        <IconButton
          variant="contained"
          color="alternative"
          onClick={onClose}
          size="small"
          data-testid="modal-header-close"
          aria-label="close"
          sx={{ alignSelf: 'center' }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  )
}
